import { render } from "./PhoneDemo.vue?vue&type=template&id=b210c00c"
import script from "./PhoneDemo.vue?vue&type=script&lang=js"
export * from "./PhoneDemo.vue?vue&type=script&lang=js"

import "./PhoneDemo.vue?vue&type=style&index=0&id=b210c00c&lang=css"

import exportComponent from "/codebuild/output/src2677690992/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__